import $ from "cash-dom";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export default (function () {
    const selector = "[data-theme]";
    let registered = false;

    function init() {
        const $themes = $(selector);

        if (!$themes.length) return;

        jdmn.log("function_ui-color.js initialized", "green");

        const $ui = $("#header");

        if (!registered) {
            gsap.registerPlugin(ScrollTrigger);
            registered = true;
        }

        /**
         * Finds the currently active theme element.
         * We always use the deepest visible matching element,
         * so nested theme sections override parent themes.
         */
        function getActiveThemeElement() {
            const scrollTop = window.scrollY + 2;

            let active = null;
            let activeDepth = -1;

            $themes.each(function () {
                const el = this;
                const rect = el.getBoundingClientRect();

                const top = rect.top + window.scrollY;
                const bottom = top + rect.height;

                // Is scroll position inside this themed area?
                if (scrollTop >= top && scrollTop < bottom) {
                    const depth = $(el).parents(selector).length;

                    // Prefer the deepest nested match
                    if (depth >= activeDepth) {
                        active = el;
                        activeDepth = depth;
                    }
                }
            });

            return active;
        }

        function updateTheme() {
            const active = getActiveThemeElement();

            // Fallback if nothing matches
            const theme = active ? $(active).data("theme") : $("#post").data("theme");

            $ui.attr("data-theme", theme);
        }

        // Create triggers for every themed element
        $themes.each(function () {
            ScrollTrigger.create({
                trigger: this,
                start: "top top+=1",
                end: "bottom-=1 top",
                onEnter: updateTheme,
                onEnterBack: updateTheme,
                onLeave: updateTheme,
                onLeaveBack: updateTheme,
            });
        });

        // Initial state
        updateTheme();

        // Refresh handling
        ScrollTrigger.addEventListener("refresh", updateTheme);
    }

    $(document).ready(init);
})();
